export default __webpack_public_path__ + "static/media/apple.c523e7c7.png";